import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import {  HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { APP_ROUTING } from './app.routes';
import { MenuComponent } from './slider/menu/menu.component';
import { FooterComponent } from './slider/footer/footer.component';
import { MainComponent } from './slider/main/main.component';
import { LoginComponent } from './login/login.component';
import { SeleccionarEmpresaComponent } from './components/seleccionar-empresa/seleccionar-empresa.component';
import { NgChartsConfiguration } from 'ng2-charts';
import { DashboardocComponent } from './components/reportes/rinventario/dashboardoc.component';
import { InicioComponent } from './components/home/inicio.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { RecuperarClaveComponent } from './components/recuperar-clave/recuperar-clave.component';
import { ReestablecerClaveComponent } from './components/recuperar-clave/reestablecer-clave.component';
import { SpinnerInterceptor } from './components/spinner/spinner.interceptor';
import { SpinnerModule } from './components/spinner/spinner.module';
import { ConfigService } from './config.service';



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    FooterComponent,
    MainComponent,
    LoginComponent,
    SeleccionarEmpresaComponent,
    DashboardocComponent,
    InicioComponent,
    RecuperarClaveComponent,
    ReestablecerClaveComponent,
  ],
  imports: [
    BrowserModule ,
    BrowserAnimationsModule,
    APP_ROUTING,
    FormsModule,
    HttpClientModule,
    CommonModule,
    //NgChartsModule, //-- comentado por migración 09082024
    //GoogleChartsModule, -- comentado por migración 09082024
    SpinnerModule
    
    // HttpClient
    
  ],
  providers: [
  
    {provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi:true },
    {
    provide: APP_INITIALIZER,
    useFactory: (configService: ConfigService) => () => configService.loadConfig(),
    deps: [ConfigService],
    multi: true
  }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
